<template>
    <button class="cta-gabarit">
        <span class="default">
            <span class="content">
                {{caption}}
            </span>
        </span>
        <span class="hover">
            <span class="content">
                {{caption}}
            </span>
        </span>
    </button>
</template>
<script>
export default {
    props: {
        caption: {
            type: String
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.cta-gabarit
    position: relative
    height: 5.2em
    font-size: 50px
    font-weight: 500
    display: flex
    align-items: center
    justify-content: center
    border: 1px solid #e5e5e5
    margin-top: 5.275%
    margin-bottom: 5.275%
    cursor: pointer
    overflow: hidden
    @include media-breakpoint-down($sm)
        font-size: 30px
.default, .hover
    display: flex
    align-items: center
    justify-content: center
.default
    position: relative
.hover
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    background: #ff2b2a
    color: #FFFFFF
    transition: transform 0.5s cubic-bezier(.65,0,.25,1)
    transform: translateY(101%)
    will-change: transform
    overflow: hidden
    .content
        position: absolute
        top: 0
        left: 0
        right: 0
        bottom: 0
        display: flex
        align-items: center
        justify-content: center
        transition: transform 0.5s cubic-bezier(.65,0,.25,1)
        transform: translateY(-101%)
        will-change: transform
.content
    position: relative
.cta-gabarit:hover
    .hover
        transform: none
        .content
            transform: none
</style>
